<template>
  <div class="tool-bar">
    <div class="logo">
      <div>MYTutor</div>
    </div>
    <div class="user-info">
      <el-dropdown v-if="userInfo" @command="handleCommand">
        <span class="el-dropdown-link">
          <div class="avatar avatar-name">
            {{ userInfo.username.charAt(0) }}
          </div>
          {{ userInfo.userAccount }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">{{$t('common.signOut')}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span v-else @click="goToLogin" style="cursor: pointer;font-family: 'AzonixRegular', sans-serif">{{$t('common.signIn')}}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

/**
 * @description 顶部工具栏组件
 */
export default {
  name: 'ToolBar',
  computed: {
    ...mapState('user', {
      userInfo: state => state.userInfo
    })
  },
  methods: {
    /**
     * @description 处理下拉菜单命令
     */
    handleCommand (command) {
      if (command === 'logout') {
        this.logout()
      }
    },
    /**
     * @description 退出登录
     */
    logout () {
      this.$store.dispatch('user/logout')
      this.$message.success(this.$t('common.logoutSuccess'))
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    },
    /**
     * @description 跳转到登录页面
     */
    goToLogin () {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.tool-bar {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  justify-content: center;
  position: relative;
  height: 80px;
  z-index: 1;
}

.logo div {
  height: 60px;
  color: #409EFF;
  font-size: 25px;
  display: flex;
  font-weight: 700;
  align-items: center;
  font-family: 'Orbitron', 'Rajdhani', sans-serif;
  letter-spacing: 2px;
  font-style: italic;
  text-transform: uppercase;
}

.slogan {
  color: #1e88e5;
  font-size: 18px;
  font-weight: bold;
}

.user-info {
  position: absolute;
  right: 24px;
  .avatar{
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
    background: #f9fbff;
    margin-right: 12px;
    color: #fff;
  }
  .avatar img {
    width: 24px;
    height: 24px;
  }
}

.el-dropdown-link {
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #409EFF;
}

.el-dropdown-link:hover {
  color: #66b1ff;
}
</style>
